import { Container, Stack, Form, Col, Row, Button, FloatingLabel, ToggleButton, Card } from "react-bootstrap";

import React, { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import { confirmAnomaly, updateAnomaly } from "./anomalyApi";
import { resetEditor } from "../dbTable/dbTablSlice";
import { UsersTable } from "../usersTable/usersTable";
import { resetPerformer } from "../usersTable/usersTableSlice";
import { toast } from "react-toastify";
import { resetAnomalyDescription, resetProblemPhotoBase64, resetAnomalyTag, setAnomalyDescription, setAnomalyTag, setProblemVideo } from "./anomalySlice";
import { ViewScreenshot } from "../ScreenShot/viewScreenshot";
import { setPageName } from "../login/loginSlice";
import { useLocation } from "react-router-dom";



function isBase64(s) {
    try {
        window.atob(s);
    } catch (e) {
        return false;
    }
    return true;
}
export function AnomalyRegistration(props) {
    const users = useSelector((state) => state.users)
    const log = useSelector((state) => state.login)
    const user = useSelector((state) => state.user)
    const editor = useSelector((state) => state.table.editor)
    const equipment = useSelector((state) => state.equipment)
    const anomaly = useSelector((state) => state.anomaly)

    const dispatch = useDispatch()
    let disableReg = false
    let navigate = useNavigate();
    const location = useLocation();
    
    var anomalyPhotoBase64 = anomaly.problemPhotoBase64
    var anomalyVideo = anomaly.problemVideo;
    var descr = ""
    var tagDescr = ""
    var closedButton = (<Fragment></Fragment>)
    var assignPerformer = (<Fragment></Fragment>)
    var performer_username = ""


    var button = (<Fragment>
        <Button variant="primary" disabled={disableReg} onClick={(e) => onRegisterAnomaly()} className="ColorBlue">Зарегистрировать аномалию</Button>
    </Fragment>)

    if (anomaly.description != "") {
        descr = anomaly.description

        dispatch(resetAnomalyDescription())
    }
    if (anomaly.tag != "") {
        tagDescr = anomaly.tag
        
        dispatch(resetAnomalyTag())
    }

    if (editor) {
        descr = editor.description
        if (!anomalyVideo)
            anomalyVideo = editor.video64
        if (anomalyPhotoBase64 === "") {
            anomalyPhotoBase64 = editor.image64
        }
        if (user.isServiceMaintaince) {
            closedButton = <Button variant="outline-secondary" className="ColorRed" onClick={(e) => onCloseAnomaly()}>Закрыть аномалию</Button>
        }
        tagDescr = editor.type
        button = (
            <Fragment>
                <Button variant="primary" onClick={(e) => onUpdateAnomaly()}>Обновить</Button>
            </Fragment>
        )
        performer_username = editor.performer_username


    }
    const [tag, setTag] = useState(tagDescr)
    const [description, setDescription] = useState(descr)
    const [isPerformer, setIsPerformer] = useState(false)

    useEffect(() => {
        if (!log.token || log.token.length === 0) {
            return navigate("/login");
        } else {
            dispatch(setPageName("Регистрация аномалии"))
        }
        if (location.pathname == '/anomaly-editor' & !editor) {
            return navigate("/db")
        }
    })

    function onRegisterAnomaly() {
        let data = { user: user.id, description: description, equipment: equipment.confirmedMachineId, type: tag, token: log.token }

        if (anomalyPhotoBase64 != null) {
            data.image64 = anomalyPhotoBase64
        } 
        if (anomaly.problemVideo){
            data.video64 = anomaly.problemVideo
        }
        if (users.performer) {
            data["performer"] = users.performer.id
        }
        if (!disableReg) {
            console.log(data, log.token)
            dispatch(resetPerformer())
            dispatch(confirmAnomaly(data))
            dispatch(resetProblemPhotoBase64())
            dispatch(setProblemVideo(null))
            return navigate("/db")
        }
        else {
            toast.error('Заполни все поля!', {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }

    }
    function onCloseAnomaly() {
        let data = {
            user: editor.user, token: log.token,
            anomaly_id: editor.id, status: "CLOSED"
        }
        if (users.performer) {
            data["performer"] = users.performer.id
        }
        if (!disableReg) {
            dispatch(resetPerformer())
            dispatch(updateAnomaly(data))
            dispatch(resetEditor())
            dispatch(resetProblemPhotoBase64())
            dispatch(setProblemVideo(null))
            return navigate("/db")
        }
        else {
            toast.error('Заполни все поля!', {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }
    function onUpdateAnomaly() {
        let data = {
            user: editor.user, description: description, equipment: equipment.confirmedMachineId, type: tag, token: log.token,
            anomaly_id: editor.id
        }
        if (anomalyPhotoBase64 != null && isBase64(anomalyPhotoBase64)) {
            data.image64 = anomalyPhotoBase64
        }
        if (anomaly.problemVideo) {
            data.video64 = anomaly.problemVideo
        }
        if (users.performer) {
            data["performer"] = users.performer.id
        }
        if (!disableReg) {
            dispatch(resetPerformer())
            dispatch(updateAnomaly(data))
            dispatch(resetEditor())
            dispatch(resetProblemPhotoBase64())
            dispatch(setProblemVideo(null))
            return navigate("/db")
        }
        else {
            toast.error('Заполни все поля!', {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }

    }

    if (user.username === "" || equipment.confirmedMachine === "" || description === "" || tag === "") {
        disableReg = true
    }
    else {
        disableReg = false
    }

    function onPerformer() {
        dispatch(setAnomalyDescription(description))
        dispatch(setAnomalyTag(tag))
        dispatch(resetPerformer())
        setIsPerformer(true)



    }
    function onMakePhoto() {
        dispatch(setAnomalyDescription(description))
        dispatch(setAnomalyTag(tag))
        return navigate("/screenshot");
    }
    // dtx 31.05.2024 {
    function onChooseEqp() {
        dispatch(setAnomalyDescription(description))
        dispatch(setAnomalyTag(tag))
        return navigate("/equipment");
    }
    // dtx 31.05.2024 }
    var chooseEqp = "Выбрать оборудование"

    if (editor && equipment.currentArea == "") {
        chooseEqp = `${editor.line_name}/${editor.area_name}/${editor.equipment_name}`
    } else if (equipment.confirmedMachine != "") {
        chooseEqp = `${equipment.currentLine}/${equipment.currentArea}/${equipment.confirmedMachine}`
    }
    var performer = "Назначить исполнителя"
    if (user.isStaff) {
        if (users.performer != null) {
            performer_username = users.performer.username
            if (performer_username != "") {
                performer = performer_username
            }
            if (isPerformer) {
                setIsPerformer(false)
            }



        }
        assignPerformer = (<Fragment>
            <div className="d-grid mt-3">
                <Button variant="outline-dark" onClick={(e) => onPerformer()} >{performer}</Button>
            </div>
        </Fragment>

        )
    }
    var scr = (<Fragment></Fragment>)
    if (anomalyPhotoBase64 != "" || anomalyVideo) {
        scr = (
            <Fragment>
                {!!anomalyVideo &&
                    <div className="d-grid mt-3">
                        <a href={anomalyVideo} target="_blank">Видео прикреплено</a>
                    </div>}
                {!!anomalyPhotoBase64 && 
                    <div className="d-grid mt-3">
                        <ViewScreenshot src={anomalyPhotoBase64} />
                    </div>}
            </Fragment>)
    }
    // if (anomalyVideo)
    //     scr = (<Fragment>
    //         <div className="d-grid mt-3">
    //             <a href={anomalyVideo} target="_blank">Видео прикреплено</a>
    //         </div>
    //     </Fragment>)


    var page = (
        <Fragment>
            <div className="d-grid mt-3">
                {/* <Button variant="outline-dark" tabIndex={0} as={Link} to="/equipment" className="ChosingEqpBtn btn btn-outline-secondary"> */}
                <Button variant="outline-dark" onClick={() => onChooseEqp()} className="ChosingEqpBtn btn btn-outline-secondary">
                    {chooseEqp} </Button>
            </div>
            <div className="mx-auto mt-3 vstack gap-3">
                <div className="row row-cols-2">
                    <Col className="text-nowrap" >

                        <Stack gap={3}>
                            <ToggleButton variant="outline-dark" type="radio" onClick={() => setTag("SECURITY")} checked={tag === "SECURITY"}  >Безопасность</ToggleButton>
                            <ToggleButton variant="outline-dark" type="radio" onClick={() => setTag("MINOR")} checked={tag === "MINOR"} >Незначительное</ToggleButton>
                            <ToggleButton variant="outline-dark" type="radio" onClick={() => setTag("BASIC_CONDITION")} checked={tag === "BASIC_CONDITION"} >Базовое состояние</ToggleButton>
                        </Stack>
                    </Col>

                    <Col className="text-nowrap" >
                        <Stack gap={3}>
                            <ToggleButton variant="outline-dark" type="radio" onClick={() => setTag("QUALITY")} checked={tag === "QUALITY"} >Качество</ToggleButton>
                            <ToggleButton variant="outline-dark" type="radio" onClick={() => setTag("POLLUTION")} checked={tag === "POLLUTION"} > Загрязнение</ToggleButton>
                            <ToggleButton variant="outline-dark" type="radio" onClick={() => setTag("HARD_TO_REACH")} checked={tag === "HARD_TO_REACH"} >Труднодоступное</ToggleButton>

                        </Stack>

                    </Col>
                </div>

            </div>
            <div className="d-grid mt-3">
                <FloatingLabel controlId="floatingTextarea2" label="Добавить описание">
                    <Form.Control
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        as="textarea"
                        placeholder="Leave a comment here"
                        onFocus={event => {
                            setTimeout(event.target.select.bind(event.target), 20);
                        }}
                    />
                </FloatingLabel>

            </div>
            {scr}
            <div className="d-grid mt-3">
                <Button variant="dark" onClick={() => onMakePhoto()} >Сфотографировать</Button>
            </div>

            {assignPerformer}

            <div className="d-grid mt-3">
                {closedButton}
            </div>
            <div className="d-grid mt-3">
                {button}
            </div>
        </Fragment>
    )

    if (isPerformer) {
        page = (<Fragment><UsersTable performer={isPerformer} /></Fragment>)
    }
    return (<Fragment>
        <div className="col-xl-5 col-lg-6 mx-auto">
            {page}

        </div>

    </Fragment>

    );
}
